var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('heading',[_vm._v(_vm._s(_vm.$t("proof.category.title")))]),_c('proofMonthStrip'),_c('proofCategoryTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }